import { ACCEPT_POLICY, SEEN_DISCLAIMER } from "../actions/acceptPolicy";

import Cookies from "js-cookie";

const acceptCookie = Cookies.get("accept-cookie");
const showDisclaimer = Cookies.get("show-disclaimer");

const initialState = {
  acceptedPolicy: acceptCookie,
  seenDisclaimer: showDisclaimer,
};

const acceptPolicy = (state = initialState, action) => {
  switch (action.type) {
    case ACCEPT_POLICY:
      return { ...state, acceptedPolicy: action.data };
    case SEEN_DISCLAIMER:
      return { ...state, seenDisclaimer: action.data };
    default:
      return state;
  }
};

export default acceptPolicy;
